import { EpicSettings, EpicSettingsFromJSON } from "../EpicSettings";
import { ProjectTimeItem, ProjectTimeItemFromJSON } from "./ProjectTimeItem";


export interface ProjectTime {
    id: number;
    subject: string;
    bitmaker_settings: EpicSettings;
    from_time: Date;
    to_time: Date;
    report: Array<ProjectTimeItem>;
}


export function ProjectTimeFromJSON(json: any): ProjectTime {
    return {
        id: json["id"],
        subject: json["subject"],
        bitmaker_settings: EpicSettingsFromJSON(json["bitmaker_settings"]),
        from_time: json["from_time"],
        to_time: json["to_time"],
        report: (json["report"] as Array<any>).map(ProjectTimeItemFromJSON),
    };
}
